module.exports = __webpack_public_path__ + "img/logo-zc.5aa9dcf7.jpg";